import { formatDataValue } from 'utils/formatFns';

export const damagesFields = {
  damageCodes: {
    label: 'Damage Codes',
    getValue: (data) => ({
      areaCode: data?.damages?.[0]?.damageLines?.[0]?.damageAreaCode,
      typeCode: data?.damages?.[0]?.damageLines?.[0]?.damageTypeCode,
      severityCode: data?.damages?.[0]?.damageLines?.[0]?.damageSeverityCode,
    }),
    formatValue: ({ areaCode, typeCode, severityCode }) => {
      const formattedArea = formatDataValue({ value: areaCode });
      const formattedType = formatDataValue({ value: typeCode });
      const formattedSeverity = formatDataValue({ value: severityCode });
      return `${formattedArea}, ${formattedType}, ${formattedSeverity}`;
    },
  },
  damageDate: {
    label: 'Damage Date',
    getValue: (data) => data?.damages?.[0]?.damageSurveyDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  damageRepairDate: {
    label: 'Damage Repair Date',
    getValue: (data) => data?.damages?.[0]?.damageIncidentRepairDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
};
